// import { dbName } from "./consts.js";


// move to folder also remove chunksConf

export const appsConf = {
    // dbName,
    // dbVersion,
    store: 'apps',
};